import {
  AVIATION_HULL_PANELS,
  AVIATION_LIABILITIES_PANELS,
  COMMERCIAL_GENERAL_LIABILITY_PANELS,
  SubCoveragePanel
} from './coverages/coverage-panels.model'

/**
 * Kinds of top-level sections in the insured detailview; decides which content a section renders.
 */
export type InsuredSectionType =
  | 'POLICY'
  | 'MEMBER'
  | 'AVIATION_HULL'
  | 'AVIATION_LIABILITIES'
  | 'COMMERCIAL_GENERAL_LIABILITY'
  | 'OBJECTS'

/**
 * One top-level accordion panel of the insured detailview.
 * Its position in `INSURED_SECTIONS` is the accordion panel value and the nav section `mainIndex`.
 */
export interface InsuredSection {
  /** Kind of section, decides the rendered content */
  readonly type: InsuredSectionType
  /** Section heading, also used as nav section label */
  readonly label: string
  /** Suffix for the section's data-test attributes (`accordion-panel-…`, `-header-…`, `-content-…`) */
  readonly dataTest: string
  /** Sub-coverage panels listed as nav sections below this section */
  readonly subPanels: readonly SubCoveragePanel[]
  /** Kept closed when the detailview loads, e.g. because opening it triggers a request. */
  readonly collapsedOnLoad: boolean
}

/** Top-level sections of the insured detailview, in display order. */
export const INSURED_SECTIONS: readonly InsuredSection[] = [
  { type: 'POLICY', label: 'General Policy Information', dataTest: 'policy', subPanels: [], collapsedOnLoad: false },
  { type: 'MEMBER', label: 'General Insured Information', dataTest: 'member', subPanels: [], collapsedOnLoad: false },
  {
    type: 'AVIATION_HULL',
    label: 'Aviation Hull',
    dataTest: 'aviation-hull',
    subPanels: AVIATION_HULL_PANELS,
    collapsedOnLoad: false
  },
  {
    type: 'AVIATION_LIABILITIES',
    label: 'Aviation Liabilities',
    dataTest: 'aviation-liabilities',
    subPanels: AVIATION_LIABILITIES_PANELS,
    collapsedOnLoad: false
  },
  {
    type: 'COMMERCIAL_GENERAL_LIABILITY',
    label: 'Commercial General Liability',
    dataTest: 'commercial-general-liability',
    subPanels: COMMERCIAL_GENERAL_LIABILITY_PANELS,
    collapsedOnLoad: false
  },
  { type: 'OBJECTS', label: 'Objects', dataTest: 'fleet-list', subPanels: [], collapsedOnLoad: true }
]
